export default () => {
  return {
    compositesMap: {},
    compositesPage: {},
  };
};
